import {EventEmitter, Injectable} from '@angular/core';
import {Observer} from 'rxjs';

@Injectable()
export class UnsavedChangesService {
  public onCheckUnsavedChanges$ = new EventEmitter<Observer<boolean>>();
}
